import React from "react";
import { NavLink } from "react-router-dom";
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";

import { InitiativeDetailsStore } from "$stores/initiative-details";

const InitiativeNav = ({ initiativeId }) => {
    const appInsights = useAppInsightsContext();
    const shortlistCount = InitiativeDetailsStore.useState((s) => s.shortlistCount);
    const activityCount = InitiativeDetailsStore.useState((s) => s.activityCount);
    const actionItemsCount = InitiativeDetailsStore.useState((s) => s.actionItemsCount);

    const basepath = `/initiatives/${initiativeId}`;

    const trackEvent = (label) => {
        appInsights.trackEvent(
            { name: "Navigation - Initiative Menu" },
            { label, page: document.title.replace(" - Orgaimi", "") }
        );
    };

    return (
        <div className="initiative-nav button-list -underline">
            <NavLink
                end
                className={({ isActive }) => (isActive ? "-active" : undefined)}
                to={`${basepath}/curate`}
                onClick={() => trackEvent("Curate")}
            >
                Curate
            </NavLink>
            <NavLink
                end
                className={({ isActive }) => (isActive ? "-active" : undefined)}
                to={`${basepath}/shortlist`}
                onClick={() => trackEvent("Shortlist")}
            >
                Shortlist
                {shortlistCount > 0 && (
                    <span className="badge badge-primary initiative-nav__badge">{shortlistCount}</span>
                )}
            </NavLink>
            <NavLink
                end
                className={({ isActive }) => (isActive ? "-active" : undefined)}
                to={`${basepath}/activity`}
                onClick={() => trackEvent("Activity")}
            >
                Activity
                {activityCount > 0 && (
                    <span className="badge badge-secondary initiative-nav__badge">{activityCount}</span>
                )}
            </NavLink>
            <NavLink
                end
                className={({ isActive }) => (isActive ? "-active" : undefined)}
                to={`${basepath}/action-items`}
                onClick={() => trackEvent("Action Items")}
            >
                Action Items
                {actionItemsCount > 0 && (
                    <span className="badge badge-primary initiative-nav__badge">{actionItemsCount}</span>
                )}
            </NavLink>
        </div>
    );
};

export default InitiativeNav;
